"use client";

import { useState } from "react";

import { Button } from "@/components/ui/button";
import { clearAllSiteCookies } from "@/utils/cookieUtils";

// Render a button that clears the browser cookies for the current site and the auth session cookie.
export function ClearCookiesButton() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [isPending, setIsPending] = useState(false);

  const handleClearCookies = async () => {
    // Clear the visible cookies from the browser and ask the server to remove the auth cookie too.
    setIsPending(true);
    setStatus("idle");

    try {
      clearAllSiteCookies();

      const response = await fetch("/api/clear-cookies", {
        method: "POST",
        credentials: "same-origin",
      });

      if (!response.ok) {
        throw new Error("Failed to clear server cookies.");
      }

      setStatus("success");
      
      // Espera 3 segundos antes de recarregar
      setTimeout(() => {
        window.location.reload();
      }, 3000);
      
    } catch (error) {
      console.error("[Cookie ERROR] Failed to clear site cookies:", error);
      setStatus("error");
    } finally {
      setIsPending(false);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      <Button type="button" variant="default" size="lg" onClick={handleClearCookies} disabled={isPending} className="rounded-full bg-[linear-gradient(135deg,#12356d,#2563eb)] px-5 py-3 text-sm font-semibold text-white shadow-md shadow-blue-950/15 transition-colors hover:brightness-110">
        {isPending ? "Limpando..." : "Limpar cookies do site"}
      </Button>
      {status === "success" ? (
        <span className="text-sm text-emerald-700" aria-live="polite">
          Cookies removidos para este site. Recarregando a página em breve...
        </span>
      ) : null}
      {status === "error" ? (
        <span className="text-sm text-red-700" aria-live="polite">
          Não foi possível limpar os cookies neste momento.
        </span>
      ) : null}
    </div>
  );
}
